import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const Container = styled(Flex)`
    gap: 8px;
    align-items: center;
`;

export const InfoDot = styled(Flex)`
    position: absolute;
    top: -5px;
    right: -5px;

    align-items: center;
    justify-content: center;

    width: 16px;
    height: 16px;

    border-radius: 50%;

    background: ${colorsPalettes.red[500]};
    ${setFontVariant("tag", colorsPalettes.carbon[0])};
`;

export const IconContainer = styled(Flex)`
    position: relative;

    align-items: center;
    justify-content: center;
    background: ${colorsPalettes.carbon[0]};

    color: ${colorsPalettes.carbon[300]};
    width: 32px;
    height: 32px;

    border-radius: 6px;
`;

export const TextContainer = styled.div`
    ${setFontVariant("tab")};
`;

export const Bold = styled.span`
    font-weight: 700;
`;
